<div class="spinner" *ngIf="isLoading; else showPage"></div>
<ng-template #showPage>
  <div class="page-wrapper">
    <app-breadcrumbs></app-breadcrumbs>
    <section>
      <div class="title-background"></div>
      <div class="content-wrapper title">
        <h1>{{ pageData.page_title }}</h1>
      </div>
      <div class="content-wrapper">
        <div class="separator"></div>
        <div class="generic-tabs-container">
          <app-generic-tabs
            [tabData]="pageTabs"
            (selectedTab)="onTabChanged($event)"
          ></app-generic-tabs>
        </div>

        <div class="displayed-page">
          <div
            class="outer-header"
            [class.split-header]="splitHeaderLayout"
            [class.mobile-image-padding]="
              currentPage.header_image_app?.data?.attributes?.url
            "
          >
            <div
              class="header-wrapper"
              [class.split-header]="splitHeaderLayout"
            >
              <div class="header-text" [class.split-header]="splitHeaderLayout">
                <h2 class="header-title">
                  {{ currentPage.header_title }}
                </h2>

                <div class="header-body">
                  <app-render-markdown
                    [content]="currentPage.header_content"
                  ></app-render-markdown>
                </div>
              </div>
              <div class="btn-container">
                <button
                  class="button"
                  *ngIf="currentPage.show_header_button"
                  (click)="navigate(currentPage?.header_button_link ?? '')"
                >
                  {{ currentPage.header_cta_text }}
                </button>
              </div>
            </div>
            <div *ngIf="splitHeaderLayout" class="desktop-image-container">
              <img
                [src]="currentPage.header_image_web?.data?.attributes?.url"
              />
            </div>
          </div>
          <img
            *ngIf="splitHeaderLayout"
            class="mobile-image"
            [src]="currentPage.header_image_app?.data?.attributes?.url"
          />

          <app-jobs-and-careers-card
            [cards]="currentPage.cards"
          ></app-jobs-and-careers-card>

          <app-student-life-banner
            [banner]="currentPage.si_banner?.data?.attributes ?? null"
            [showBanner]="currentPage.show_si_banner ?? false"
            [useSecondaryButton]="true"
          ></app-student-life-banner>
        </div>
      </div>
    </section>
  </div>
</ng-template>
